import useBreakPointBasedProp from "@/hooks/useBreakPointBasedProp";
import TestOrderIcon from "@/images/TestOrderIcon";

export default function OrderIcon({
  color,
  width,
  iconSize,
  style,
  variant = "filled",
  withCircle = false
}) {
  const w = useBreakPointBasedProp(width);
  const innerIconSize = useBreakPointBasedProp(iconSize);
  return (
    <TestOrderIcon
      color={color}
      width={w}
      iconSize={innerIconSize}
      style={style}
      variant={variant}
      withCircle={withCircle}
    />
  );
}
